import React, { Fragment } from 'react';
import Button from '../common/forms/button';
import TextInput from '../common/forms/text-input';
import { Link, Navigate } from 'react-router-dom';
import Checkbox from '../common/forms/checkbox';
import ValidationError from '../common/forms/validation-error';
import Error from '../common/forms/error';

function User(props){

    if (props.rdr) {
        return <Navigate to={props.rdr} />
    }

    let emailLinkPopup = null

    if(props.emailLink && props.lightBoxOpen){
        emailLinkPopup = <div className="cover">
            <div className="hover-box">
                <Link to='/admin/manage/users' className="close-lnk">Close</Link>
                <h2>Invite Link</h2>
                <div className="flash-msg grn">
                    The user has been created successfully.
                </div>
                <p>You can send the link below to the new user so they can set up a password for their account.</p>
                <p className="lnk-wrap">{props.emailLink}</p>
            </div>
        </div>
    }

    return (
        <Fragment>
            {emailLinkPopup}
            <section className='width-9 centred'>

                <h1>{props.isUserEdit ? 'Edit user details' : 'Create a new user'}</h1>

                <Error error={props.error}/>
                
                <TextInput label='First Name' id='firstName' value={props.settings.firstName} fieldName="firstName" handleChange={props.handleUpdate }/>
                <TextInput label='Last Name' id='lastName' value={props.settings.lastName} fieldName="lastName" handleChange={props.handleUpdate }/>
                <TextInput label='Email' id='email' value={props.settings.email} fieldName="email" handleChange={props.handleUpdate }/>
                <ValidationError errors={props.valErrors} fieldName='email'/>
                <TextInput label='Phone' id='phone' value={props.settings.phone} fieldName="phone" handleChange={ props.handleUpdate }/>
                
                <ValidationError errors={props.valErrors} fieldName='client' />

                <div className="permissions">
                    <h6>User permissions</h6>
                    <Checkbox label='Manage website content' id='manage' checked={props.permissions['Manage']} handleChange={(e) => props.handlePermissionsUpdate('Manage', e)} />
                    <Checkbox label='View financial reports' id='reports' checked={props.permissions['Reports']} handleChange={(e) => props.handlePermissionsUpdate('Reports',e)}/>
                    <Checkbox label='Manage users' id='Users' checked={props.permissions['Users']}  handleChange={(e) => props.handlePermissionsUpdate('Users',e)}/>
                </div>

                {!props.isUserEdit &&
                    <Checkbox label='Display the invitation link, so I can email it to the user myself' id='return_link' handleChange={(e) => props.setReturnEmailLink(e.target.checked)}/>
                }
                <Button btnTxt={props.btnTxt} id='save_btn' handleClick={props.saveUser}/>
            </section>
  
        </Fragment>
    )
}

export default User